import { Link } from 'react-router-dom';
import { SEO } from '../../shared/components/SEO';

export function NotFound() {
  return (
    <>
      <SEO title="Page Not Found (404) | ZFAST Agritech India" description="The page you are looking for could not be found." path="/404" />
      <section className="mx-auto max-w-3xl px-4 py-24 text-center sm:px-6 lg:px-8">
        <p className="text-sm font-black uppercase tracking-[0.24em] text-gold">404</p>
        <h1 className="mt-3 text-5xl font-black text-ink">Page not found</h1>
        <p className="mt-5 text-lg text-charcoal/70">The page may have moved or the product route is not available yet.</p>
        <Link to="/" className="mt-8 inline-flex rounded-full bg-forest px-6 py-3 font-black text-ink">Go home</Link>
      </section>
    </>
  );
}
